// Keep estimates in sync with Blum's existing variant-selection event.
// Cart messaging is server-rendered within the theme's AJAX cart fragments.
(() => {
  if (customElements.get('inochi-klarna-message')) return;
  class InochiKlarnaMessage extends HTMLElement {
    connectedCallback() {
      if (this.dataset.context === 'cart' || this.onVariantChange) return;
      this.section = document.getElementById(this.dataset.section);
      if (!this.section) return;
      this.onVariantChange = (event) => {
        const selector = event.target.closest('sht-variant-radios, sht-variant-selects');
        if (!selector) return;
        // Blum updates its selected variant synchronously in the child handler.
        queueMicrotask(() => {
          const variant = selector.currentVariant;
          const visible = !!variant?.available && Number.isSafeInteger(variant.price) && variant.price > 0;
          this.hidden = !visible;
          this.section.querySelectorAll('[data-inochi-klarna-badge]').forEach(badge => { badge.hidden = !visible; });
          if (!visible) return;
          this.dataset.amount = String(variant.price);
          this.querySelector('[data-inochi-installment]').textContent = new Intl.NumberFormat(this.dataset.locale, {
            style: 'currency', currency: 'EUR', minimumFractionDigits: 2, maximumFractionDigits: 2,
          }).format(Math.round(variant.price / 3) / 100);
        });
      };
      this.section.addEventListener('change', this.onVariantChange);
    }
    disconnectedCallback() {
      this.section?.removeEventListener('change', this.onVariantChange);
      this.onVariantChange = null;
    }
  }
  customElements.define('inochi-klarna-message', InochiKlarnaMessage);
})();
